<template>
  <q-select
      ref="select"
      v-bind="allAttrs"
      :options="optionsArray"
      :aria-label="this.label"
      :rules="requiredRules"
      outlined
  >
    <slot />
  </q-select>
</template>

<script>
import Base from './Base'
import OptionsMixin from './OptionsMixin'

export default {
  extends: Base,
  mixins: [OptionsMixin],
  props: {
    options: {
      type: [Array, Object],
      required: true
    }
  }
}
</script>